import ApiService from '../api/ApiService';
import Config from '../constants/Config';
import Urls from '../api/Urls';
import MarkupBundle from './../models/MarkupBundle';

export function getMarkupBundle(params) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.MARKUP_BUNDLE_LIST,
        params: params,
        parser: markupBundlesDataParser,
    }).get();
}

export function getMarkupBundleDetail(id) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.MARKUP_BUNDLE_DETAIL,
        endpointParams: { id },
        parser: (data) => new MarkupBundle(data.data),
    }).get();
}

export function createMarkupBundleDetail(markupBundle) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.MARKUP_BUNDLE_ACTION,
        parser: (data) => new MarkupBundle(data.markupBundle),
    }).post(markupBundle.export());
}

export function updateMarkupBundleDetail(markupBundle) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.MARKUP_BUNDLE_ACTION,
        parser: (data) => new MarkupBundle(data.markupBundle),
    }).put(markupBundle.export());
}

export function deleteMarkupBundleDetail(markupBundle) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.MARKUP_BUNDLE_DETAIL,
        endpointParams: { id: markupBundle.id }
    }).delete();
}

const markupBundlesDataParser = (data) => ({
    result: (data.data.result || data.data).map(item => new MarkupBundle(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})